import styled from "styled-components"

export default {
    "Wrapper": styled.button`
        display: flex;
        align-items: center;
        gap: 16px;
            
        & > p {
            width: 100%;
            text-align: left;
            ${({ theme }) => theme.font["large-medium"]};
        }
    `,
    "Icon": styled.img`
        width: 20px;
        min-width: 20px;
        height: 20px;
        object-fit: contain;
    `,
    "Arrow": styled.img`
        width: 20px;
        height: 12px;
        object-fit: contain;
        object-position: right;
    `,
}